<template>
  <foreignObject :x="x" :y="y" :width="size" :height="size">
    <b-badge :variant="variant"><slot></slot></b-badge>
  </foreignObject>
</template>

<script>
  export default {
    name: 'SvgBadge',

    props: {
      x: Number,
      y: Number,
      variant: String,
      scale: Number,
    },

    computed: {
      size() {
        return Math.round(this.scale * 200);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
